import * as Highcharts from "highcharts";
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/offline-exporting';

import { openChartInfo } from '../charts/info';

import { Aeroval } from "../../types/global";
declare var aeroval: Aeroval;

const markerEnabledThreshold =
    typeof aeroval !== "undefined" && aeroval.settings?.markerEnabledThreshold
        ? Number(aeroval.settings.markerEnabledThreshold)
        : 2;

Highcharts.setOptions({
    chart: {
        backgroundColor: 'transparent',
        events: {
            fullscreenOpen: function () {
                // fullscreen background color
                const fullScreenBackgroundColor = aeroval.settings.theme == 'dark' ? '#282b34' : 'white';
                (this as any).update({
                    chart: {
                        backgroundColor: fullScreenBackgroundColor,
                    },
                });
            },
            fullscreenClose: function () {
                (this as any).update({
                    chart: {
                        backgroundColor: 'transparent',
                    },
                });
            }, load: function () {
                const chart = this;

                function handleLegendItemDblClick(
                    event: MouseEvent,
                    selectedSeries: Highcharts.Series
                ) {
                    event.preventDefault();
                    event.stopPropagation();

                    aeroval.seriesVisibility = {};

                    chart.series.forEach((s) => {
                        const name = s.name.toLowerCase();

                        // Always keep target/guide visible
                        if (name === "target" || name.startsWith("guide")) {
                            return;
                        }

                        const visible = s === selectedSeries;

                        s.setVisible(visible, false);
                        aeroval.seriesVisibility[s.name] = visible;
                    });

                    chart.redraw();
                }

                chart.series.forEach((series) => {
                    const legendItem = (series.legendItem as any)?.group?.element;

                    if (!legendItem) return;

                    // Avoid duplicate listeners when chart is recreated
                    legendItem.ondblclick = (event: MouseEvent) =>
                        handleLegendItemDblClick(event, series);
                });
            }
        }
    },
    credits: {
        enabled: false,
    },
    accessibility: {
        enabled: false,
    },
    exporting: {
        enabled: true,
        allowHTML: true,
        buttons: {
            contextButton: {
                menuItems: [{
                    text: 'About',
                    onclick: function () {
                        const chart = this as any;
                        openChartInfo(chart.renderTo.id);
                    }
                }, "separator", "viewFullscreen", "separator", "downloadPNG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
            }
        } as any,
        chartOptions: {
            chart: {
                events: {
                    load: function (this: any) {
                        if (this.resetZoomButton) {
                            this.resetZoomButton.hide();
                        }
                    }
                },
                zooming: {
                    resetButton: {
                        theme: {
                            visibility: 'hidden'
                        }
                    }
                }
            }
        }
    },
    title: {
        useHTML: true
    },
    subtitle: {
        useHTML: true
    },
    yAxis: {
        title: {
            useHTML: true
        },
        labels: {
            useHTML: true
        }
    },
    xAxis: {
        title: {
            useHTML: true
        }
    },
    time: {
        timezone: 'UTC'
    },
    tooltip: {
        outside: true,
    },
    plotOptions: {
        series: {
            marker: {
                enabledThreshold: markerEnabledThreshold
            }
        }
    }
});

if (window.location.href.includes('reports')) {
    Highcharts.setOptions({
        chart: {
            style: {
                fontSize: '1em'
            },
            reflow: true
        },
        exporting: {
            enabled: false,
        },
        title: {
            style: {
                fontSize: '0.9em'
            },
        },
        subtitle: {
            style: {
                fontSize: '0.7em'
            },
        },
        legend: {
            itemStyle: {
                fontSize: '0.6em'
            },
        },
        yAxis: {
            title: {
                style: {
                    fontSize: '0.7em'
                },
            },
        },
        xAxis: {
            title: {
                style: {
                    fontSize: '0.7em'
                },
            },
        },
    });
}